import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/hooks-intro.html"
      }}>{`React Hook`}</a>{` that gives
you the ability to add a callback function when an event is triggered on
an object.`}</p>
    <p>{`This function attaches an event listener to a target object on mount
and removes the listener on unmount.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener"
      }}>{`addEventListener()`}</a></p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`EventTarget`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget"
            }}>{`EventTarget`}</a>{` to attach the listener to`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/Events"
            }}>{`Event`}</a>{` to listen for, e.g. 'resize', 'error', etc.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`listener`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function that is invoked when the event is triggered`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...rest`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other arguments to pass to the addEventListener() function`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/hooks/useEventListener.js"
      }}>{`pwa-studio/packages/peregrine/lib/hooks/useEventListener.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      